(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__productCardQuickAddInit) return;
  window.__productCardQuickAddInit = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    if (btn.disabled || btn.hasAttribute('data-loading')) return;

    var variantId = btn.getAttribute('data-variant-id');
    var cardLink = btn.closest('.product-card');
    if (!variantId) return;

    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', 1);

    btn.setAttribute('data-loading', 'true');
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (data) {
            throw new Error((data && data.description) || 'Add to cart failed');
          });
        }
        return r.json();
      })
      .then(function () {
        btn.removeAttribute('data-loading');
        btn.disabled = false;
        btn.setAttribute('data-added', 'true');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        setTimeout(function () {
          btn.removeAttribute('data-added');
        }, 1500);
      })
      .catch(function (err) {
        console.error('Quick add failed', err);
        btn.removeAttribute('data-loading');
        btn.disabled = false;
        if (cardLink && cardLink.getAttribute('href')) {
          window.location.assign(cardLink.getAttribute('href'));
        }
      });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
